import { render, staticRenderFns } from "./MyStatesPage.vue?vue&type=template&id=76b99999"
import script from "./MyStatesPage.vue?vue&type=script&lang=js"
export * from "./MyStatesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports